"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var formik_1 = require("formik");
var react_1 = __importStar(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var Field_1 = __importDefault(require("../components/Field"));
var Label_1 = __importDefault(require("../components/Label"));
var Input_1 = __importDefault(require("../inputs/Input"));
var StyledInput = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", "\n"], ["\n  ",
    "\n"])), function (_a) {
    var maxWidth = _a.maxWidth;
    return maxWidth && styled_components_1.css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      max-width: 179.3px;\n    "], ["\n      max-width: 179.3px;\n    "])));
});
var StyledField = styled_components_1.default(Field_1.default)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  ", "\n"], ["\n  ",
    "\n"])), function (_a) {
    var displayFlex = _a.displayFlex;
    return displayFlex && styled_components_1.css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n      column-gap: 0em;\n      display: flex;\n      margin: 0;\n\n      & > *:first-child {\n        flex: auto;\n      }\n\n      & > *:last-child {\n        flex: auto;\n      }\n\n      & + & {\n        margin-top: 0;\n      }\n    "], ["\n      column-gap: 0em;\n      display: flex;\n      margin: 0;\n\n      & > *:first-child {\n        flex: auto;\n      }\n\n      & > *:last-child {\n        flex: auto;\n      }\n\n      & + & {\n        margin-top: 0;\n      }\n    "])));
});
var NumberField = function (_a) {
    var name = _a.name, label = _a.label, displayFlex = _a.displayFlex, size = _a.size, placeholder = _a.placeholder, maxWidth = _a.maxWidth, toolTip = _a.toolTip, maxLength = _a.maxLength, defValue = _a.defValue, readOnly = _a.readOnly;
    var _b = formik_1.useField(name), field = _b[0], meta = _b[1], helpers = _b[2];
    react_1.useEffect(function () {
        if (defValue)
            helpers.setValue(defValue.value);
    }, [defValue === null || defValue === void 0 ? void 0 : defValue.value]);
    react_1.useEffect(function () {
        if (field.value === '')
            helpers.setValue(undefined);
    }, [field.value]);
    var handleKeyDown = function (evt) {
        if (['e', 'E', '+', '-', '.', ','].includes(evt.key)) {
            evt.preventDefault();
        }
    };
    return (react_1.default.createElement(StyledField, { displayFlex: displayFlex },
        label && react_1.default.createElement(Label_1.default, { htmlFor: name }, label),
        react_1.default.createElement(StyledInput, { maxWidth: maxWidth },
            react_1.default.createElement(Input_1.default, __assign({}, field, { value: field.value, name: name, hasError: !!meta.error, size: size, type: "number", placeholder: placeholder, onKeyDown: handleKeyDown, toolTip: toolTip, maxLength: maxLength, onWheel: function (e) { return e.target.blur(); }, readOnly: readOnly })))));
};
NumberField.defaultProps = {
    displayFlex: false,
    size: undefined,
    placeholder: undefined,
    toolTip: undefined,
    maxWidth: false,
    maxLength: undefined,
    defValue: undefined,
    label: undefined,
    readOnly: undefined,
};
exports.default = NumberField;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
